<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>
<div class="container m-t-rel" *ngIf="tool">
  <div class="columns">
    <div class="column is-12-desktop">
      <h1 class="title is-2 mb-0">{{ tool.name }}</h1>
    </div>
  </div>
</div>
<div class="tool-wrapper" *ngIf="tool">
  <div class="container mb-6">
    <div class="columns">
      <!-- Main content -->
      <div class="column is-8 pt-0">
        <div class="field is-grouped is-grouped-multiline mb-6 mt-3">
          <div class="control" *ngIf="tool.websiteLink">
            <a
              class="tags has-addons ghost"
              [href]="tool.websiteLink"
              target="_blank"
            >
              <span
                class="tag is-small is-primary-bis is-flex is-align-items-center"
                ><i class="fas fa-globe"></i
              ></span>
              <span class="tag is-small is-white-bis">Website</span>
            </a>
          </div>
          <div class="control" *ngIf="tool.githubLink">
            <a
              class="tags has-addons ghost"
              [href]="tool.githubLink"
              target="_blank"
            >
              <span class="tag is-small is-dark is-flex is-align-items-center">
                <i class="fab fa-github"></i
              ></span>
              <span class="tag is-small is-white-bis">Github</span>
            </a>
          </div>
          <div class="control" *ngIf="tool.huggingFaceLink">
            <a
              class="tags has-addons ghost"
              [href]="tool.huggingFaceLink"
              target="_blank"
            >
              <span class="tag is-small is-dark is-flex is-align-items-center">
                <i class="far fa-laugh-beam"></i>
              </span>
              <span class="tag is-small is-white-bis">Hugging Face</span>
            </a>
          </div>
          <div class="control" *ngIf="tool.toolPackage">
            <a
              class="tags has-addons ghost"
              [href]="tool.toolPackage"
              target="_blank"
            >
              <span
                class="tag is-small is-danger-bis is-flex is-align-items-center"
                ><i class="fas fa-box-open"></i
              ></span>
              <span class="tag is-small is-white-bis">Tool package</span>
            </a>
          </div>
          <div class="control" *ngIf="tool.slackLink">
            <a
              class="tags has-addons ghost"
              [href]="tool.slackLink"
              target="_blank"
            >
              <span
                class="tag is-small is-link-bis is-flex is-align-items-center"
              >
                <i class="fab fa-slack"></i
              ></span>
              <span class="tag is-small is-white-bis">Slack</span>
            </a>
          </div>
          <div class="control" *ngIf="tool.gitLabLink">
            <a
              class="tags has-addons ghost"
              [href]="tool.gitLabLink"
              target="_blank"
            >
              <span
                class="tag is-small is-warning-bis is-flex is-align-items-center"
              >
                <i class="fab fa-gitlab"></i
              ></span>
              <span class="tag is-small is-white-bis">Gitlab</span>
            </a>
          </div>
        </div>
        <hr class="has-background-white-bis mt-0" />
        <nav class="level is-size-7 my-4">
          <!-- Left side -->
          <div class="level-left taxonomy-list">
            <div
              class="level-item"
              *ngIf="
                (tool.approaches && tool.approaches.length) ||
                (tool.countries && tool.countries.length) ||
                tool.duration
              "
            >
              <span class="icon-text tool-relations">
                <div class="is-flex mr-4 my-1">
                  <span
                    class="icon"
                    *ngIf="tool.approaches && tool.approaches.length"
                  >
                    <i
                      class="icon icon-TopicsRelatedtotheResults is-size-7 has-text-primary"
                    ></i>
                  </span>
                  <ng-container *ngFor="let approach of tool.approaches">
                    <span class="country-label sans content is-small mb-0">
                      <a
                        (click)="
                          goToFilteredList(
                            'approachIds',
                            approach.id.toString()
                          )
                        "
                        (keydown)="
                          goToFilteredList(
                            'approachIds',
                            approach.id.toString()
                          )
                        "
                        tabindex="0"
                      >
                        {{ approach.name }}
                      </a>
                    </span>
                  </ng-container>
                </div>
                <div class="is-flex mr-4 my-1">
                  <span
                    class="icon"
                    *ngIf="tool.countries && tool.countries.length"
                  >
                    <i class="icon icon-Public is-size-7 has-text-primary"></i>
                  </span>
                  <span
                    *ngFor="let country of tool.countries"
                    class="country-label sans content is-small mb-0"
                  >
                    <a
                      (click)="
                        goToFilteredList('countryIds', country.id.toString())
                      "
                      (keydown)="
                        goToFilteredList('countryIds', country.id.toString())
                      "
                      tabindex="0"
                    >
                      {{ country.name }}
                    </a></span
                  >
                </div>
                <div class="is-flex mr-4 my-1" *ngIf="tool.duration">
                  <span class="icon">
                    <i class="far fa-clock is-size-7 has-text-primary"></i>
                  </span>
                  <span class="duration-label sans content is-small mb-0">
                    {{ tool.duration }}
                  </span>
                </div>
              </span>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right">
            <span class="content is-small">
              Uploaded on {{ tool.publishedAt | date }}
            </span>
          </div>
        </nav>
        <hr class="has-background-white-bis mb-6" />
        <figure class="media-left" *ngIf="tool.image">
          <p class="image">
            <img
              *ngIf="tool.image"
              [src]="storagePath + tool.image + '-landscape.jpg'"
              [alt]="tool.name"
            />
          </p>
        </figure>

        <div *ngIf="content" [innerHTML]="content"></div>

        <ng-container *ngIf="tool.relatedPost">
          <div class="card bg-white card--related-post">
            <h2 class="title is-3 mb-0">AI Wonk post about this tool</h2>
            <app-post-card
              [post]="tool.relatedPost"
              [layout]="PostLayout.List"
            ></app-post-card>
          </div>
        </ng-container>
      </div>

      <!-- Taxonomy sidebar -->
      <div class="column is-4 pb-0">
        <div class="card bg-white taxonomy-relation-list">
          <h3 class="is-size-5 mt-6 mb-5">About the tool</h3>
          <div class="is-size-7">
            <div class="block block--link">
              <p class="my-0">
                You can click on the links to see the associated tools
              </p>
            </div>

            <ng-container *ngFor="let taxonomy of sidebarTaxonomies">
              <ng-container
                *ngIf="
                  tool[taxonomy.propName] && tool[taxonomy.propName].length
                "
              >
                <hr class="has-background-white-bis" />
                <div
                  class="is-flex is-align-items-flex-start is-justify-content-center"
                >
                  <p class="my-0 is-bold">{{ taxonomy.label }}:</p>
                  <ul class="my-0 ml-0 no-lst">
                    <li *ngFor="let item of tool[taxonomy.propName]">
                      <a
                        *ngIf="taxonomy.queryParamName"
                        (click)="
                          goToFilteredList(taxonomy.queryParamName, item.id)
                        "
                        (keydown)="
                          goToFilteredList(taxonomy.queryParamName, item.id)
                        "
                        tabindex="0"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </ng-container>
            <hr class="has-background-white-bis" />
            <div
              class="is-flex is-align-items-flex-start is-justify-content-center"
              *ngIf="tool.tags && tool.tags.length"
            >
              <p class="my-0 is-bold">Tags:</p>
              <ul class="my-0 ml-0 no-lst">
                <li *ngFor="let tag of tool.tags">
                  <span>{{ tag.name }}</span>
                </li>
              </ul>
            </div>

            <ng-container *ngIf="tool.githubStars > 0">
              <hr class="has-background-white-bis" />
              <div
                class="is-flex is-align-items-flex-start is-justify-content-center"
              >
                <p class="my-0 is-bold">Github stars:</p>
                <ul class="my-0 ml-0 no-lst">
                  <li>
                    <span>{{ tool.githubStars }}</span>
                  </li>
                </ul>
              </div>
            </ng-container>
            <ng-container *ngIf="tool.githubForks > 0">
              <hr class="has-background-white-bis" />
              <div
                class="is-flex is-align-items-flex-start is-justify-content-center"
              >
                <p class="my-0 is-bold">Github forks:</p>
                <ul class="my-0 ml-0 no-lst">
                  <li>
                    <span>{{ tool.githubForks }}</span>
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </div>
        <p class="has-text-right mt-4 mb-0">
          <a
            (click)="showReportToolModal = true"
            (keydown)="showReportToolModal = true"
            tabindex="0"
            class="flag-link has-text-primary is-size-6 no-deco"
          >
            <i class="icon icon-Assignedtomyself1 mr-2"></i>
            <span>Modify this tool</span>
          </a>
        </p>
      </div>
    </div>
  </div>
  <div
    class="container-full bg-theme has-text-light is-relative"
    *ngIf="tool?.toolUseCases"
  >
    <div class="has-glow"></div>
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="mt-6 mb-4">Use Cases</h2>
        </div>
      </div>
      <div class="columns pb-4 is-multiline">
        <div class="column is-4" *ngFor="let useCase of tool.toolUseCases">
          <div
            class="card card--use-case pointer"
            [routerLink]="[
              '/catalogue',
              'tools',
              tool.slug,
              'tool-use-cases',
              useCase.slug
            ]"
          >
            <div class="card-image" *ngIf="useCase.image">
              <figure class="image is-4by3">
                <img
                  *ngIf="useCase.image"
                  [src]="storagePath + useCase.image + '-videoCard.jpg'"
                  [alt]="useCase.name"
                />
                <img
                  *ngIf="!useCase.image"
                  src="./assets/images/blog-default.png"
                  [alt]="useCase.name"
                />
              </figure>
            </div>
            <div class="card-image" *ngIf="!useCase.image">
              <figure class="image is-4by3">
                <img
                  src="./assets/images/charts-for-trends.png"
                  [alt]="useCase.name"
                />
              </figure>
            </div>
            <div class="card-content">
              <span
                *ngIf="useCase.organisations && useCase.organisations.length"
                >{{ useCase.organisations[0].name }}</span
              >
              <h4
                class="mt-2 card--use-case__title"
                [routerLink]="[
                  '/catalogue',
                  'tools',
                  tool.slug,
                  'tool-use-cases',
                  useCase.slug
                ]"
              >
                {{ useCase.name }}
              </h4>
              <div class="content is-small content--usecase">
                {{ useCase.content | stripHtml | truncate : [250] }}
              </div>
              <span class="content is-small">{{
                useCase.publishedAt | date
              }}</span>
            </div>
            <br />
          </div>
        </div>
        <div *ngIf="tool?.toolUseCases.length === 0">
          There is no use cases for this tool yet.
        </div>
        <div class="column is-12">
          <div class="cta--add-usecase has-text-centered">
            <div class="p-a-xxl">
              <h3 class="has-text-light">
                Would you like to submit a use case for this tool?
              </h3>
              <p>
                If you have used this tool, we would love to know more about
                your experience.
              </p>
              <a
                [routerLink]="['/catalogue', 'tool-use-cases', 'submit']"
                [queryParams]="{ toolSlug: tool.slug }"
                class="button is-white"
                >Add use case</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="columns">
      <div class="column">
        <!-- External links -->
        <div class="column is-5" *ngIf="tool.externalLinks">
          <p class="is-size-6 mt-0 is-bold mb-4">External links</p>

          <div
            class="tags has-addons"
            *ngFor="let externalLink of tool.externalLinks"
          >
            <span
              class="tag is-dark"
              *ngIf="externalLink.type && externalLink.type.length"
            >
              {{ externalLink.type[0].name }}</span
            >
            <span class="tag is-info">
              {{ externalLink.date | date }}
            </span>
            <span class="tag">
              <a
                href="{{ externalLink.url }}"
                target="_blank"
                rel="noopener noreferrer"
                >{{ externalLink.label | stripHtml }}
              </a></span
            >
          </div>
        </div>

        <app-document-list
          *ngIf="tool.documents && tool.documents.length"
          [documents]="tool.documents"
        ></app-document-list>
      </div>
    </div>
  </div>
</div>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>

<!-- Report tool modal-->
<app-flag-modal
  *ngIf="showReportToolModal"
  [resourceId]="tool.id"
  [resourceType]="ResourceSlug.Tools"
  (modalClosed)="showReportToolModal = false"
></app-flag-modal>
